/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quiet_Thin_Whale_NoteInputs */

const en_quiet_thin_whale_note = /** @type {(inputs: Quiet_Thin_Whale_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`First name`)
};

const de_quiet_thin_whale_note = /** @type {(inputs: Quiet_Thin_Whale_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorname`)
};

/**
* | output |
* | --- |
* | "First name" |
*
* @param {Quiet_Thin_Whale_NoteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const quiet_thin_whale_note = /** @type {((inputs?: Quiet_Thin_Whale_NoteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quiet_Thin_Whale_NoteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_quiet_thin_whale_note(inputs)
	return de_quiet_thin_whale_note(inputs)
});